
<select [(ngModel)]="currentConfig" (change)="onChangeConfig($event.target.value)" class="professional-select" >
	<option *ngFor="let config of availableConfigs" [value]="config" [selected]="currentConfig === config">
		{{ config }}
	</option>
</select>
